import React from 'react';
import DateFnsUtils from '@date-io/moment';
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from '@material-ui/pickers';
import { useSelector, useDispatch } from 'react-redux';
import { IReduxState } from '../../types';
import {
  updateStartDate,
  updateEndDate,
  updateMachineTelemetryData,
  fetchMachineDetails,
} from '../../actions/machineDetailsActions';
import {
  Button,
  makeStyles,
  Theme,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  Box,
  List,
  ListItem,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import GetAppIcon from '@material-ui/icons/GetApp';
import SearchIcon from '@material-ui/icons/Search';
import { useWindowSize } from '../useWindowSize';
import { themeColors } from '../../constants/theme';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    //marginTop:  theme.spacing(-4),
    zIndex: 1,
    flexGrow: 1,
  },
  cardWrapper: {
    [theme.breakpoints.up('xs')]: {
      margin: `${theme.spacing(5)}px 0`,
    },
    [theme.breakpoints.up('sm')]: {
      margin: `${theme.spacing(2)}px`,
      // height: 400,
    },
  },
  card: {
    // [theme.breakpoints.up('xs')]: {
    //   marginBottom: `${theme.spacing(2)}px`,
    // },
    // [theme.breakpoints.up('md')]: {
    //   margin: `0 ${theme.spacing(2)}px`,
    // },
   borderTop: `2px solid ${themeColors.yellow}`,
  },
  cardContent: {
    margin: `0 ${theme.spacing(1)}px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
    justifyContent: 'space-between',
    height: '100%',
    padding: 0,
    paddingBottom: 0,
  },
  list: {
    display: 'block',
    width: '100%', 
  },
  listItemTitle: {
    marginLeft: theme.spacing(1),
    maxHeight: theme.spacing(4),
  },
  listItemContent: {
    marginLeft: theme.spacing(-1),
    maxHeight: theme.spacing(11),
    width: '100%',
    maxWidth: '100%',
    display: 'flex', 
    alignItems: 'center',
  },  
  datePickerWrapper: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexDirection: 'row',
    padding: 0,
  },
  datePicker: {
    margin: `${theme.spacing(2)}px`,
  },
  buttonWrapper: {
    marginBottom: `${theme.spacing(2)}px`,
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      margin: `0 ${theme.spacing(2)}px`,
    },
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonWrapperRight: {
    marginBottom: `${theme.spacing(2)}px`,
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      margin: `0 ${theme.spacing(2)}px`,
    },
    position: 'absolute',
    right: '-10px',
  },
  updateButtonWrapper: {
    position: 'relative',
  },
  updateButtonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  title: {
      marginTop: theme.spacing(2),
  },
}));

interface IProps {
  onCreateReport: any;
}

export default function GraphControls(props: IProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const size = useWindowSize();
  const startDate = useSelector(
    (state: IReduxState) => state.machineDetails.search.startDate
  );
  const endDate = useSelector(
    (state: IReduxState) => state.machineDetails.search.endDate
  );
  const isFetchingTelemtry = useSelector(
    (state: IReduxState) => state.machineDetails.isFetchingTelemtry
  );
  const machineId = useSelector(
    (state: IReduxState) => state.machineDetails.machine.id
  );

  const isSmallScreen =
    size.width !== undefined && size.width > 600 && size.width < 800
      ? true
      : false;

  return (
    <div className={classes.root}>
      <div className={classes.cardWrapper}>
        <Card
          className={classes.card}
          style={isSmallScreen ? { marginTop: 0 } : { marginTop: '-32px' }}
        >
          <CardContent
            className={classes.cardContent}
            style={{ paddingBottom: 0 }}
          >
            <List className={classes.list}>
              <ListItem className={classes.listItemTitle}>
                <Typography
                    variant="h5"
                    className={classes.title}
                >
                    {t('graph.reportingPeriod')}
                </Typography>
              </ListItem>
              <ListItem className={classes.listItemContent}>
                <div className={classes.datePickerWrapper}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDateTimePicker
                      className={classes.datePicker}
                      margin="normal"
                      id="start-date-picker"
                      label={t('graph.startDate')}
                      ampm={false}
                      format="DD/MM/YYYY HH:mm"
                      value={startDate}
                      maxDate={endDate}
                      //@ts-ignore
                      onChange={(date: Date) => dispatch(updateStartDate(date))}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      strictCompareDates
                      disableFuture                  
                    />
                    <KeyboardDateTimePicker
                      className={classes.datePicker}
                      margin="normal"
                      id="end-date-picker"
                      label={t('graph.endDate')}
                      ampm={false}
                      format="DD/MM/YYYY HH:mm"
                      value={endDate}
                      minDate={startDate}
                      maxDate={new Date()}
                      //@ts-ignore
                      onChange={(date: Date) => dispatch(updateEndDate(date))}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      strictCompareDates
                      disableFuture
                    />
                  </MuiPickersUtilsProvider>
                  <div className={classes.updateButtonWrapper}>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<SearchIcon />}
                      disabled={isFetchingTelemtry}
                      onClick={() =>
                        {
                          // Update der Daten
                          dispatch(fetchMachineDetails(machineId, endDate));
                          dispatch(updateMachineTelemetryData(startDate, endDate, machineId));
                        }
                      }
                    >
                      {size.width !== undefined &&
                        size.width > 700 &&
                        t('graph.update')}
                    </Button>
                    {isFetchingTelemtry && (
                      <CircularProgress
                        size={24}
                        className={classes.updateButtonProgress}
                      />
                    )}
                  </div>
                </div>
                <div className={classes.buttonWrapperRight}>
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<GetAppIcon />}
                    disabled={!!isFetchingTelemtry ? true : false}
                    onClick={() => props.onCreateReport()}
                  >
                    {t('report.report')}
                  </Button>
                </div>
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
